{
  "label": "etiqueta",
  "name": "nombre",
  "gamme": "gama",
  "serialNumber": "Número de serie",
  "firmwareVersion": "Versión de software",
  "status": "Estado",
  "sector": "Red",
  "certificate": "Certificado",
  "connectivity": "Conectividad",
  "applicationDate": "Fecha de aplicación",
  "date": "Fecha",
  "startDate": "Fecha de inicio",
  "endDate": "Fecha de finalización",
  "id": "Id",
  "search": "Búsqueda"
}
